
import { Component, Vue, Prop } from "vue-property-decorator";
import {
  ZuzhijiagouList,
  UsersList,
  ResetPwd,
  BanApplyAccount,
} from "@/request/doctor";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import NavLeft from "../../../main/components/nav-left/nav-left.vue";
import Pagination from "@/components/paginaiton.vue";
@Component({
  components: {
    MainHeader,
    NavLeft,
    Pagination,
  },
})
export default class Name extends Vue {
  private filter: any = {
    search: "",
    institution_id: "",
    current_page: 1,
    page_count: 10,
    sort_value: 1,
  };
  private totalCount: any = null;
  private totalPage: any = 0;
  private window: any = window;
  private users: any[] = [];
  private jigous: any[] = [];
  private H: any = "";
  private get localFilter() {
    if (!localStorage.getItem("accountFilter")) {
      return {};
    } else {
      return JSON.parse(localStorage.getItem("accountFilter") || "");
    }
  }
  private set localFilter(val) {
    if (!val) {
      return;
    }
    localStorage.setItem("accountFilter", JSON.stringify(val));
  }
  /**
   * @description 跳转添加用户
   */
  private jumpAddUser() {
    this.$router.push({
      path: "/main/doctor/account-compose-user",
    });
  }
  /**
   * @description 搜索
   */
  private search() {
    this.filter.current_page = 1;
    this.fetchUsers();
  }
  /**
   * @description 处理排序变化
   */
  private handleSortChange(ev: any) {
    this.filter.sort_value = ev["order"] === "ascending" ? "1" : "0";
    this.search();
  }
  /**
   * @description 处理页码变化
   */
  private handleCurrentPageChange(val: any) {
    this.filter.current_page = val;
    this.fetchUsers();
  }
  /**
   * @description 处理翻页器的每页条数变化
   */
  private handleCurrentSizeChange(val: any) {
    this.filter.current_page = 1;
    this.filter.page_count = val;
    this.fetchUsers();
  }
  /**
   * @description 按照机构来查找
   */
  private searchInstitution(id: any) {
    this.filter["institution_id"] = id;
    this.search();
  }
  /**
   * @description 重置用户密码
   */
  private resetPwd(user: any) {
    this.$confirm("确定要重置该账号的密码吗？")
      .then(() => {
        const params: any = {
          doctor_id: user.doctor_id,
        };
        ResetPwd(this, params).then((data: any) => {
          this.$message.success("重置成功");
        });
      })
      .catch((e) => {
        console.log(e);
      });
  }
  /**
   * @description 禁用或启用账号
   */
  private banApplyAccount(user: any) {
    const action: any = user["状态"] === "禁用" ? "启用" : "禁用";
    if (action === "禁用") {
      this.$confirm("禁用后该账户不能进入该网站，确定要禁用吗？")
        .then(() => {
          const params: any = {
            doctor_id: user.doctor_id,
            动作: action,
          };
          BanApplyAccount(this, params).then((data: any) => {
            this.$message.success(action + "成功");
            this.fetchUsers();
          });
        })
        .catch((e) => {
          console.log("取消了");
        });
    } else {
      const params: any = {
        doctor_id: user.doctor_id,
        动作: action,
      };
      BanApplyAccount(this, params).then((data: any) => {
        this.$message.success(action + "成功");
        this.fetchUsers();
      });
    }
  }
  /**
   * @description 自动计算角色
   */
  private calJuese(juese: any) {
    let jigouText = "";
    juese["组织机构"].forEach((jigou: any) => {
      jigouText += jigou["名称"] + "-";
    });
    jigouText = jigouText.substring(0, jigouText.length - 1);
    return juese["role"]["名称"] + "(" + jigouText + ")";
  }
  /**
   * @description 跳转用户编辑
   */
  private jumpCompose(user: any) {
    if (user["状态"] === "禁用") {
      this.$message.warning("该账户已经禁用，不能编辑");
      return;
    }
    this.$router.push({
      path: "/main/doctor/account-compose-user",
      query: {
        id: user.doctor_id,
      },
    });
  }
  /**
   * @description 获取组织架构列表
   */
  private fetchJigouList() {
    const params: any = {};
    ZuzhijiagouList(this, params).then((data: any) => {
      data.forEach((first: any) => {
        if (first["sub_institutions"]) {
          first["open"] = true;
          first["sub_institutions"].forEach((second: any) => {
            if (second["sub_institutions"]) {
              second["open"] = true;
            } else {
              second["open"] = false;
            }
          });
        } else {
          first["open"] = false;
        }
      });
      this.jigous = data;
    });
  }
  /**
   * @description 获取用户列表
   */
  private fetchUsers() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params = {
      search: this.filter.search,
      institution_id: this.filter.institution_id,
      current_page: this.filter.current_page,
      page_count: this.filter.page_count,
      sort_value: this.filter.sort_value,
    };
    UsersList(this, params)
      .then((data: any) => {
        loading.close();
        this.localFilter = this.filter;
        this.users = data.doctors;
        this.totalCount = data.total_count;
        this.totalPage = data.total_page;
      })
      .catch(() => {
        loading.close();
        localStorage.setItem("accountFilter", "");
      });
  }
  mounted() {
    this.H = document.body.clientHeight - 100;
    if (localStorage.getItem("accountFilter")) {
      this.filter = JSON.parse(localStorage.getItem("accountFilter") as any);
    }
    this.fetchJigouList();
    this.fetchUsers();
  }
}
